import { render, staticRenderFns } from "./PublicEditalLayout.vue?vue&type=template&id=12970a1a&scoped=true&lang=pug&"
import script from "./PublicEditalLayout.vue?vue&type=script&lang=js&"
export * from "./PublicEditalLayout.vue?vue&type=script&lang=js&"
import style0 from "./PublicEditalLayout.vue?vue&type=style&index=0&id=12970a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12970a1a",
  null
  
)

export default component.exports